import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Moment from 'react-moment';
import startCase from 'lodash/startCase';
import PropTypes from 'prop-types';
import {
  Header,
  Icon,
  Message,
  Segment,
} from 'semantic-ui-react';

import { cardType, planType } from '../types';

import CCInfo from './cc';

import '../../stylesheets/account.css';

import { sendGetCard, sendGetPlan } from '../../modules/account';
import chargifyCc from './chargifyCc';

class Usage extends Component {
  componentDidMount() {
    const { connectedSendGetCard, connectedSendGetPlan } = this.props;
    connectedSendGetCard();
    connectedSendGetPlan();
  }

  isLoading = () => {
    const { getCardRequestOut, getPlanRequestOut } = this.props;
    return getCardRequestOut || getPlanRequestOut;
  }

  renderAccountDisabled = () => (
    <Message warning>
      <Message.Header content="Account Disabled" />
      <Message.Content>
        This account is disabled and will not be able to create any more recognitions.
        <br />
        Please contact
        <a href="mailto:support@remeeting.com"> support </a>
        for assistance.
      </Message.Content>
    </Message>
  )

  chargedOn = () => {
    const { card, plan } = this.props;
    if (card) {
      return (
        <div className="re is-flex-auto">
          { `$${plan.balance.toFixed(2).toLocaleString()} will be charged on ` }
          <Moment date={plan.due} format="MM/DD/YYYY" />
        </div>
      )
    }
    return (
      <div className="re is-flex-auto">
        { `$${plan.balance.toFixed(2).toLocaleString()} ` }
      </div>
    )
  }

  renderBalance = () => {
    return (
      <div className="re is-padding-bottom-16px is-flex is-flex-align-baseline">
        <div className="usage-title">
          Balance
        </div>
        { this.chargedOn() }
      </div>
    );
  }

  renderCreditCard = () => {
    const { card, plan } = this.props;
    return (
      <div className="re is-padding-bottom-16px is-flex is-flex-align-baseline">
        <div className="usage-title">
          Credit card
        </div>
        <Icon name="credit card" />
        <div className="re is-flex-auto">
          { card
            ? `${chargifyCc[card.type]} ${card.number.replace(/X/g, '*').replace(/-/g, ' ')}`
            : 'No credit card on file'
          }
        </div>
        { plan && <CCInfo /> }
      </div>
    );
  }

  renderNoPlan = () => (
    <Message warning>
      <Message.Header content="No Plan Found" />
      <Message.Content>
        This account is not set up to automatically bill.
        <br />
        Please contact
        <a href="mailto:support@remeeting.com"> support </a>
        if you wish to set this up.
      </Message.Content>
    </Message>
  )

  renderPlan = () => {
    const { plan } = this.props;
    return (
      <div className="re is-padding-top-16px is-flex is-padding-bottom-16px">
        <div className="usage-title">
          Plan
        </div>
        <div className="re is-flex-auto">
          { plan.name }
        </div>
      </div>
    );
  }

  renderStatus = () => {
    const { plan } = this.props;
    return (
      <div className="re is-padding-bottom-16px is-flex is-padding-bottom-16px">
        <div className="usage-title">
          Status
        </div>
        <div className="re is-flex-auto">
          { startCase(plan.state) }
        </div>
      </div>
    );
  }

  printUsage = () => {
    const { plan } = this.props;
    if (plan.usage[0].value > 1000) {
      return plan.usage[0].value.toFixed(0).toLocaleString()
    }
    return plan.usage[0].value.toFixed(2).toLocaleString()
  }

  renderUsage = () => {
    return (
      <div className="re is-flex">
        <div className="usage-title">
          Transcription
        </div>
        <div className="re is-flex-auto">
          { `${this.printUsage()} minutes at $0.01/min` }
        </div>
      </div>
    );
  }

  render() {
    const { plan } = this.props;
    return (
      <Segment loading={this.isLoading()}>
        <div className="re is-border-bottom is-padding-bottom-16px is-flex is-flex-row is-flex-justify-space-between is-flex-align-center">
          <Header as="h2" className="re is-header-item">
            Billing and Usage
          </Header>
          <p>as of <Moment format="MM/DD/YYYY" /></p> {/* eslint-disable-line react/jsx-one-expression-per-line */}
        </div>
        { plan && plan.state === 'canceled' && this.renderAccountDisabled() }
        { plan ? this.renderPlan() : this.renderNoPlan() }
        { plan && this.renderStatus() }
        { this.renderCreditCard() }
        { plan && this.renderBalance() }
        { plan && plan.usage && plan.usage.length
            && this.renderUsage() }
      </Segment>
    );
  }
}

Usage.propTypes = {
  card: cardType,
  plan: planType,
  getCardRequestOut: PropTypes.bool.isRequired,
  getPlanRequestOut: PropTypes.bool.isRequired,
  connectedSendGetCard: PropTypes.func.isRequired,
  connectedSendGetPlan: PropTypes.func.isRequired,
};

Usage.defaultProps = {
  card: null,
  plan: null,
};

const mapStateToProps = state => ({
  card: state.account.card,
  getCardRequestOut: state.account.getCardRequestOut,
  getPlanRequestOut: state.account.getPlanRequestOut,
  plan: state.account.plan,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  connectedSendGetCard: sendGetCard,
  connectedSendGetPlan: sendGetPlan,
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Usage);
